<script setup lang="ts">
import ListItem from './ListItem.vue'
import ListSearchInput from './ListSearchInput.vue'
import { useUserListsQuery } from '~~/src/composables/query/lists/useUserlistsQuery'
import type { Elemental } from '~~/src/types/elemental'
import type { List } from '~~/src/types/list'
import TransitionReorder from '@/components/Transition/Reorder/index.vue'
const props = defineProps<Props>()
defineEmits<{
  (name: 'selected', event: List): void
}>()
const element = toRef(props, 'element')
const listIds = defineModel('listIds', { default: [] as string[] })
interface Props {
  element?: Elemental | null
  type?: ElementalTypeEnum | null
  isLoading?: boolean
  saveOnSelect?: boolean
}
const user = useUser()
const hasUser = computed(() => !!user.value)
const userId = computed(() => user.value?.id)
const listSearch = ref<string>()
const query = computed(() => ({
  size: 0,
  search: listSearch.value,

}))
const { data: lists, isLoading: loadingLists, refetch } = useUserListsQuery({
  userId,
  query,
}, {
  enabled: hasUser,
})

const listSort = computed(() => (
  lists.value
    ? lists.value.length > 1
      ? lists.value?.toSorted((listA, listB) => {
        const list = listIds.value
        const isSaveListA = list.includes(listA.id)
        const isSaveListB = list.includes(listB.id)
        return isSaveListA === isSaveListB ? 0 : isSaveListA ? -1 : 1
      })
      : lists.value
    : []))

onBeforeMount(() => {
  if (user.value)
    refetch()
})
</script>

<template>
  <div class="flex flex-col gap-2 bg-white">
    <ListSearchInput v-model="listSearch" />
    <TransitionReorder class="flex flex-col gap-1 isolate overflow-y-auto max-h-64 no-scrollbar ">
      <li v-if="loadingLists || isLoading" class="flex items-center justify-center p-2" :max-lines="1">
        <div class="i-mdi:loading animate-spin w-4 h-4" />
      </li>
      <li v-else-if="lists && lists.length < 1" class="flex items-center justify-center p-2 text-darkGray font-inter font-700 text-sm truncate">
        No lists found.
      </li>
      <ListItem v-for="(list, index) in listSort" :key="list.id" :tabindex="index + 2" :list="list" :list-ids="listIds" :elemental="element" :type="type" :save-on-select="true" :title="list.title" @selected="$emit('selected', $event)" />
    </TransitionReorder>
  </div>
</template>
